import React from 'react';
import AngularIcon from './angular';
import CSSIcon from './css3';
import GatsbyIcon from './gatsby';
import GitIcon from './git';
import GraphQLIcon from './graphql';
import HTMLIcon from './html5';
import JSIcon from './javascript';
import LinuxIcon from './linux';
import MongoDBIcon from './mongodb';
import MySQLIcon from './mysql';
import NodeJSIcon from './nodejs';
import ReactIcon from './react';
import ReduxIcon from './redux';
import TSIcon from './typescript';
import AdobeIllustratorIcon from './adobe-illustrator';
import AdobePhotoshopIcon from './adobe-photoshop';
import AdobeXdIcon from './adobe-xd';
import BootstrapIcon from './bootstrap';
import DockerIcon from './docker';
import FigmaIcon from './figma';
import JestIcon from './jest';
import MaterialUiIcon from './material-ui';
import RxjsIcon from './rxjs';
import SassIcon from './sass';
import VSCodeIcon from './vscode';
import WebpackIcon from './webpack';
import WordpressIcon from './wordpress';
import AndroidIcon from './android';
import JavaIcon from './java';
import KotlinIcon from './kotlin';
import SwiftIcon from './swift';
import XCodeIcon from './xcode';
import FirebaseIcon from './firebase';

const classes = 'tech-icon w-6 m-2';

export default {
  angular: <AngularIcon classes={classes} />,
  css: <CSSIcon classes={classes} />,
  gatsby: <GatsbyIcon classes={classes} />,
  git: <GitIcon classes={classes} />,
  graphql: <GraphQLIcon classes={classes} />,
  html: <HTMLIcon classes={classes} />,
  js: <JSIcon classes={classes} />,
  linux: <LinuxIcon classes={classes} />,
  mongodb: <MongoDBIcon classes={classes} />,
  mysql: <MySQLIcon classes={classes} />,
  nodejs: <NodeJSIcon classes={classes} />,
  react: <ReactIcon classes={classes} />,
  redux: <ReduxIcon classes={classes} />,
  ts: <TSIcon classes={classes} />,
  adobeillustrator: <AdobeIllustratorIcon classes={classes} />,
  adobephotoshop: <AdobePhotoshopIcon classes={classes} />,
  adobexd: <AdobeXdIcon classes={classes} />,
  bootstrap: <BootstrapIcon classes={classes} />,
  docker: <DockerIcon classes={classes} />,
  figma: <FigmaIcon classes={classes} />,
  jest: <JestIcon classes={classes} />,
  materialui: <MaterialUiIcon classes={classes} />,
  rxjs: <RxjsIcon classes={classes} />,
  sass: <SassIcon classes={classes} />,
  vscode: <VSCodeIcon classes={classes} />,
  webpack: <WebpackIcon classes={classes} />,
  wordpress: <WordpressIcon classes={classes} />,
  android: <AndroidIcon classes={classes} />,
  java: <JavaIcon classes={classes} />,
  swift: <SwiftIcon classes={classes} />,
  kotlin: <KotlinIcon classes={classes} />,
  xcode: <XCodeIcon classes={classes} />,
  firebase: <FirebaseIcon classes={classes} />
};
